/**
 * จับคู่หัวคอลัมน์ไฟล์นำเข้า (รอบจ่าย) กับประเภทรายการ.
 * เดิมต้องตรงตัวอักษรเป๊ะ — ชีทจริงของ HR เขียน "หักชีท.jst." / "ภ.ง.ด.1" / "เงินเดือน / Saraly"
 * ไม่ตรงป้าย "หักชีท/JST" / "ภงด.1" / "เงินเดือน" → คอลัมน์ถูกทิ้งเงียบ ยอดไม่ขึ้นสลิป.
 */

/** ตัดช่องว่าง จุด เครื่องหมาย และตัวพิมพ์ใหญ่ออก: "หักชีท.jst." กับ "หักชีท/JST" = "หักชีทjst" */
export function normHeader(s: string): string {
  return s.toLowerCase().replace(/[\s.,/\\\-_():]+/g, '');
}

/** คืน code ของประเภทที่ตรง หรือ null ถ้าไม่ตรง/กำกวม (ตรงหลายประเภท = ไม่เดา) */
export function matchTypeByHeader(header: string, types: Array<{ code: string; label: string }>): string | null {
  const h = header.trim();
  if (!h) return null;
  const lower = h.toLowerCase();
  // ทั้งหัว + แต่ละท่อนที่คั่นด้วย "/" (หัวสองภาษา เช่น "เงินเดือน / Saraly")
  const candidates = [h, ...(h.includes('/') ? h.split('/') : [])].map(normHeader).filter(Boolean);

  const exact = types.filter((t) => t.code === lower || candidates.includes(normHeader(t.label)));
  if (exact.length === 1) return exact[0]!.code;
  if (exact.length > 1) return null;

  // "สาย" ↔ "หักสาย", "ขาดงาน" ↔ "หักขาดงาน" — ไม่สนคำนำหน้า "หัก"
  const strip = (s: string) => s.replace(/^หัก/, '');
  const stripped = candidates.map(strip);
  const loose = types.filter((t) => stripped.includes(strip(normHeader(t.label))));
  return loose.length === 1 ? loose[0]!.code : null;
}

/** code ของประเภทใหม่: ป้ายไทยล้วนเดิมได้ code เป็นเลข ("ภงด.1" → "1") ชนกันง่าย → ใช้รหัสสุ่มแทน */
export function newTypeCode(label: string, taken: Set<string>): string {
  const slug = label.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 30);
  const base = /[a-z]/.test(slug) ? slug : `t_${Date.now().toString(36)}`;
  let code = base;
  for (let n = 2; taken.has(code); n++) code = `${base}_${n}`;
  return code;
}
